<template>
  <v-container fluid class="word-container lato purpBg">
    <!--=================================================================FIND-WORDS===-->
    <div class="d-flex flex-column justify-start align-center ma-12 mb-2"
      :style="{top: (searched) ? '0px':'60px !important'}">
      <span class="scrabbleTitle paral">Scrabble Word Finder</span>
      <div class="basicForm d-flex justify-center align-start">
        <input
          class="basicInput rale d-flex justif-left align-center"
          placeholder="Enter letters..."
          type="text"
          v-on:keyup.enter="findWords"
          v-model="letters"/>
        <button 
          class="basicButton rale d-flex justify-center align-center"
          @click="findWords">Find Words!
        </button>
      </div>
      <p class="instructions lato" v-if="(letters.length==0)">Enter up to 14 letters, with up to 2 '?' for blanks.</p>
      <p class="instructions lato" v-else>
        {{checkChars.slice(0,checkChars.length - 1)}} and
        {{parseInt(checkChars.slice(checkChars.length-1, checkChars.length))}}
        blank<span 
        v-if="parseInt(checkChars.slice(checkChars.length-1, checkChars.length))!=1">s</span>.
      </p>
    </div>
    <!--=================================================================Filter==-->
    <div class="advSearch d-flex justify-center align-start mt-0 pt-0 mb-8" v-if="searched">
      <input
          class="filterInput rale d-flex justif-left align-center"
          placeholder="Filter Results..."
          type="text"
          v-model="filter"/>
    </div>
    <!--================================================================WORD-TABLES==-->
    <div class="tableHolder d-flex flex-wrap justify-center align-start">
      <v-card class="table pa-5 ma-3"
        v-for="size in sizes" 
        :key="size"
        dark>
        <v-card-title class="avenir cntrTxt fs20 pb-3 ma-0">{{size + 2}} Letter Words<v-spacer></v-spacer></v-card-title>
        <v-data-table 
          class="dataTable elevation-1"
          :headers="headers"
          :items="items[[size]]"
          :sort-by="'PTS'"
          :sort-desc="true"
          :search="filter"
          light
          dense
          calculate-widths
          rows-per-page="15"
          multi-sort>
        </v-data-table>
      </v-card>
    </div>
  </v-container>
</template>
<!--=================================================================================-->
<!--=====================================================================SCRIPTS=====-->
<!--=================================================================================-->
<script>
/*eslint no-console: "error"*/
/*eslint no-console: ["error", { allow: ["log", "error"] }] */
import axios from 'axios';
export default {
  name: "WordComponent",
  data() {
    return {
      letters: "",
      filter: null,
      sizes: [],
      words: [],
      searched: false,
      headers: [
        {
          text: 'Word',
          align: 'center',
          sortable: true,
          value: 'Word',
          width: "80px",
          padding: "0"
        },
        {
          text: 'PTS',
          align: 'center',
          sortable: true,
          value: 'PTS',
          width: "50px",
          padding: "0"
        }
      ],
      items: [[], [], [], [], [], [], [], [], [], [], [], []],
      alf: [
        "A","B","C","D","E","F","G", "H","I", "J", "K", "L", "M","N", "O",
        "P", "Q", "R","S","T","U", "V","W", "X","Y", "Z", "?"
      ]
    };
  },
  watch: {
    words() {
      if (this.searched) {
        for (var r = 0; r < this.words.data[[0]].length; r++) {
          var obj = {};
          obj["Word"] = this.words.data[[0]][r];
          obj["PTS"] = this.words.data[[1]][r];
          this.items[[this.words.data[[0]][r].length - 2]].push(obj);
          if (!this.sizes.includes(this.words.data[[0]][r].length - 2)) {
            this.sizes.push(this.words.data[[0]][r].length - 2);
          }
        }
      }
      this.sizes.sort().reverse();
    },
    letters() {
      this.letters = this.letters.toUpperCase();
    }
  },
  computed: {
    checkChars() {
      var wilds = 0;
      var output = [];
      var input = this.letters;
      for (var y = 0; y < input.length; y++) {
        for (var i = 0; i < 27; i++) {
          if (input[y] == this.alf[i] && i == 26 && wilds < 2) {
            wilds++;
          } else if (input[y] == this.alf[i] && i < 26) {
            output.push(input[y]);
            i++;
          }
        }
      }
      output = output.slice(0, 14 - wilds);
      output.push(wilds.toString());
      return output;
    }
  },
  methods: {
    async findWords() {
      if (this.searched) {
        this.sizes.splice(0);
        this.words.data.splice(0);
        for (var c = 0; c < 12; c++) {
          this.items[[c]].splice(0);
        }
      }
      var letters = this.checkChars;
      this.words = await axios.get('/api/findwords', { params: {letters} });
      this.searched = true;

    }
  },
  async created() {
    try { this.words = await axios.get('/api/findwords');
    } catch (err) { this.error = err.message;}
  }
};
</script>
<!--=================================================================================-->
<!--=====================================================================STYLING=====-->
<!--=================================================================================-->
<style scoped>
.word-container {
  width: 100vw;
  min-height: 100vh;
  height: auto;
  margin: 0;
  position: relative;
  left: 0;
  padding: 0;
  padding-top: 100px;
  top: 0px;
  overflow:hidden;}
.scrabbleTitle{ font-size: calc(30px + 2vw); color: white;}
.basicInput{
  width: 300px;
  height: 50px;
  font-size: 20px;
  padding-left: 10px;
  margin: 0;
  outline: none;
  background-color: white;
  border: 4px solid #323232;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;}
.basicButton{
  width: 150px;
  height: 50px;
  font-size: 20px;
  outline: none;
  margin: 0;
  background-color: #4EA792 ;
  border: 4px solid #323232;
  border-left: none;
  text-align: center;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;}
.basicButton:hover{ background-color: #8961A0;}
.filterInput{
  width: 350px;
  height: 50px;
  font-size: 20px;
  padding-left: 10px;
  margin: 0;
  outline: none;
  background-color: white;
  border: 4px solid #323232;
  border-radius: 15px;}
.instructions{
  font-size: calc(16px + 0.5vw);
  color: white;}
.tableHolder{
  height: auto;
  margin-bottom: 100px;}
table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
  padding: 0 10px
}
</style>
